import { useEffect } from 'react';
import useVersionCheck from '../../Hooks/useVersionCheck';
import NewVersionModal from '../NewVersionModal/NewVersionModal';

const VersionChecker = ({ children }) => {
  const { isNewVersionAvailable, refreshApp, simulateNewVersion } = useVersionCheck();

  useEffect(() => {
    // Exponer funciones de debugging en window para testing
    window.versionCheck = {
      simulateNewVersion,
      refreshApp
    };
    
    console.log('🔧 Funciones de debugging disponibles en window.versionCheck');
    console.log('   - window.versionCheck.simulateNewVersion() - Simular nueva versión');
    console.log('   - window.versionCheck.refreshApp() - Recargar app');
    
    return () => {
      delete window.versionCheck;
    };
  }, [simulateNewVersion, refreshApp]);

  return (
    <>
      {children}
      <NewVersionModal 
        isOpen={isNewVersionAvailable} 
        onRefresh={refreshApp} 
      />
    </>
  );
};

export default VersionChecker; 